// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1t3wp","optionsDownloadBankAccount":"styles_optionsDownloadBankAccount__3rNb1"};